
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 512.129 512.129"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M161.342 350.832l120.688-30.16 229.392-229.36-90.56-90.56-229.36 229.408-30.16 120.672zM420.862 46l45.312 45.312-22.624 22.576-45.264-45.248L420.862 46zm-45.2 45.312l45.2 45.2L273.774 283.6l-45.248-45.264L375.662 91.312zm-161.04 178.32l27.92 27.92-37.232 9.296 9.312-37.216z"}}),_c('path',{attrs:{"d":"M256.062 480.112C132.35 479.883 32.248 379.408 32.478 255.697c.23-123.712 100.704-223.813 224.415-223.584a224 224 0 0158.912 7.999l8.512-30.8C188.04-28.345 47.038 51.602 9.38 187.879s42.289 277.28 178.567 314.938 277.28-42.289 314.938-178.567c.138-.499.274-.998.409-1.498l-30.896-8.304c-26.466 97.713-115.103 165.589-216.336 165.664z"}}),_c('path',{attrs:{"d":"M480.062 256.112c0 9.721-.626 19.431-1.872 29.072l31.744 4.096c1.411-11 2.122-22.078 2.128-33.168v-.768l-32 .768zM477.998 225.584l31.728-4.304a256.98 256.98 0 00-6.864-33.424l-30.848 8.512a221.123 221.123 0 015.984 29.216z"}})])
          )
        }
      }
    